module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/6-9fbbb940333edab7b9a5703c3701e424.jpg";